import { ReactNode, ButtonHTMLAttributes } from 'react';
import { clsx } from 'clsx';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'error';
  size?: 'sm' | 'md' | 'lg';
  as?: 'button' | 'span';
}

export function Button({
  children,
  variant = 'default',
  size = 'md',
  className,
  as: Component = 'button',
  ...props
}: ButtonProps) {
  const baseClasses = clsx(
    'rounded-xl backdrop-blur-xl font-medium transition-all duration-300 inline-flex items-center justify-center',
    'active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed',
    {
      'glass-button': variant === 'default' || variant === 'secondary',
      'glass-button-primary': variant === 'primary',
      'bg-success-500/30 border border-success-400/50 hover:bg-success-500/50 hover:border-success-400/70': variant === 'success',
      'bg-error-500/30 border border-error-400/50 hover:bg-error-500/50 hover:border-error-400/70': variant === 'error',
      'px-4 py-2 text-sm': size === 'sm',
      'px-6 py-3 text-base': size === 'md',
      'px-8 py-4 text-lg': size === 'lg',
    },
    className
  );

  return (
    <Component className={baseClasses} {...(props as any)}>
      {children}
    </Component>
  );
}
